import { ReactNode, useRef } from "react";
import { ScrollContext } from "./ScrollContext";

type ScrollBehaviorType = ScrollBehavior | undefined;

type ScrollContextValue = {
    contentRef: React.RefObject<HTMLDivElement> | undefined;
    scrollToTop: (behavior?: ScrollBehaviorType) => void;
};

type Props = {
    children: ReactNode;
};

export const ScrollProvider = ({ children }: Props) => {
    const contentRef = useRef<HTMLDivElement | null>(null);

    const scrollToTop = (behavior: ScrollBehaviorType = "instant") => {
        contentRef.current?.scrollTo({
            top: 0,
            behavior,
        });
    };

    const value: ScrollContextValue = {
        contentRef,
        scrollToTop,
    };

    return (
        <ScrollContext.Provider value={value}>
            {children}
        </ScrollContext.Provider>
    );
};